'use client';

import {useSearchParams} from 'next/navigation';
import {useContext} from 'react';

import {CaptchaProvider, CaptchaTokenPayload} from '../types';
import {CaptchaContext} from './CaptchaContext';
import {MockCaptcha} from './parts/MockCaptcha';
import {ProviderProps} from './parts/providerProps';
import {VkCaptcha} from './parts/VkCaptcha';
import {YandexCaptcha} from './parts/YandexCaptcha';

type Props = {
  language?: 'en' | 'ru';
  onResult: (payload: CaptchaTokenPayload) => void;
  onError: () => void;
  /** любой a-z_ текст с намеком на то, где показали капчу */
  placement: string;
  className?: string;
};

const ProviderImplementations: Record<
  CaptchaProvider,
  React.FC<ProviderProps>
> = {
  yandex: YandexCaptcha,
  vk: VkCaptcha,
  mock: MockCaptcha,
};

export const Captcha = ({
  language,
  placement,
  className,
  onResult,
  onError,
}: Props) => {
  const {provider, allowBypassCaptcha, disabled} = useContext(CaptchaContext);
  const params = useSearchParams();
  const renderMockCaptcha = allowBypassCaptcha && params?.has('autotest');

  if (disabled) {
    return null;
  }

  const renderedProvider: CaptchaProvider = renderMockCaptcha
    ? 'mock'
    : provider;

  const Component = ProviderImplementations[renderedProvider];

  return (
    <Component
      language={language}
      placement={placement}
      className={className}
      onError={onError}
      onResult={onResult}
    />
  );
};
